module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAAxUlEQVRoQ+2YQQqDMBBFJzlOkqVXklyp5Eqly4EcJjBFiWVaSnXT3XOjxig4Zr7//SBzyzm3EMJ6nG/7McbSe3/4sSvHKaUaY7z5uWZWVbVdud/PKaUsInL/eFZT1bqNBV7gS0n5Aq4oLCGaeC4HVMj1hZkhoz//R8goMjorgBd6Vw7M3FEPZPTM0yOjyCgyChO/ugAig8ggMoItosW9C0glSCXOPLS7jp3GTmOnsdPY6b0CJHMkcyIgJUgJUoKUIOVfkfIJBHiAbbj3oWgAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/openclick.png
// module id = +lDB
// module chunks = 1